/* eslint-disable camelcase */
import { OutboundLink } from 'gatsby-plugin-google-analytics';

const getTacticName = (tactic, t) => {
    const TACTICS = [
        { 'reconnaissance': t('Reconnaissance') },
        { 'resource-development': t('Resource Development') },
        { 'initial-access': t('Initial Access') },
        { 'execution': t('Execution') },
        { 'persistence': t('Persistence') },
        { 'privilege-escalation': t('Privilege Escalation') },
        { 'defense-evasion': t('Defense Evasion') },
        { 'credential-access': t('Credential Access') },
        { 'discovery': t('Discovery') },
        { 'lateral-movement': t('Lateral Movement') },
        { 'collection': t('Collection') },
        { 'command-and-control': t('Command and Control') },
        { 'exfiltration': t('Exfiltration') },
        { 'impact': t('Impact') },
    ];

    const tacticsFiltered = TACTICS.filter((value) => {
        const valueKey = Object.keys(value)[0];
        return tactic.indexOf(valueKey) > -1;
    });

    return tacticsFiltered.reduce((info, value) => {
        return info.concat(Object.values(value));
    }, []) || [];
};

export const MINIMUM_TABLE_ROWS_DISPLAYED = 5;

export const processModalData = (info, t) => {
    return ([
        {
            key: t('ATT&CK ID'),
            value: info[0]?.attckId?.join(', ') || '-',
        },
        {
            key: t('Tactics'),
            value: info[0]?.version || '-',
        },
        {
            key: t('Permissions Required'),
            value: info[0]?.permissionsRequired || '-',
        },
        {
            key: t('Source'),
            value: <OutboundLink
                href={info[0]?.url}
                rel='noopener noreferrer'
                target='_blank'
            >
                {info[0]?.url}
            </OutboundLink> || '-',
        },
        {
            key: t('Malicious Indicators'),
            value: info[0]?.maliciousIndicators?.map((indicator, index) => (
                indicator?.description && <ul key={index} className='maliciousIndicators'>
                    <li>
                        <OutboundLink
                            href={indicator?.url}
                            rel='noopener noreferrer'
                            target='_blank'
                        >
                            {indicator?.source_name}
                        </OutboundLink>
                    </li>
                    <li>
                        <p>{indicator?.description}</p>
                    </li>
                </ul>
            )) || '-',
            className: 'danger'
        }
    ]);
};

export const TABLE_LEGEND = (t) => [
    {
        title: t('Critical'),
        key: 'critical',
        color: 'stizza'
    },
    {
        title: t('High'),
        key: 'high',
        color: 'redStop'
    },
    {
        title: t('Medium'),
        key: 'medium',
        color: 'turmericRoot'
    },
    {
        title: t('Low'),
        key: 'low',
        color: 'lemonFlesh'
    },
];

const addAnchorTags = (data) => {
    // eslint-disable-next-line no-useless-escape
    const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    return data.replace(urlRegex, (url) => {
        return `<a href='${url}' rel='noopener noreferrer' target='_blank'>${url}</a>`;
    });
};

export default (t) => {
    return [
        {
            header: t('ID'),
            accessor: 'id'
        },
        {
            header: t('Tactics'),
            accessor: 'tactics',
            parser: (data) => getTacticName(data, t)
        },
        {
            header: t('Permissions Required'),
            accessor: 'permissionsRequired'
        },
        {
            header: t('Description'),
            accessor: 'description',
            parser: (data) => addAnchorTags(data)
        }
    ];
};
